import React from 'react';

import { getLabelElements } from '@eika-kortbetjening/card-list-panel';
import { KbjCard, KbjCardMeta, SiteCoreDictionary } from '@eika-kortbetjening/types';

import './InfoLabels.scss';

interface InfoLabelsProps {
    card: KbjCard;
    cardMeta: KbjCardMeta;
    dictionary: SiteCoreDictionary;
}

const InfoLabels = ({ card, cardMeta, dictionary }: InfoLabelsProps) => {
    const elements = getLabelElements(card, cardMeta, dictionary);

    if (elements.length === 0) {
        return null;
    }

    return <div className="card-info-labels">{elements}</div>;
};

export default InfoLabels;
